import { defineMessages } from 'react-intl';

export const messages: {
	cancelButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	consentCheckboxLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	displayFeedbackButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	displayFeedbackSelectorText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	feedbackTextAreaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	feedbackTextAreaRequired: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	feedbackTypeSelectorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	harmfulContentDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	harmfulContentFeedbackTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	incorrectFlagCheckboxLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	incorrectFlagDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	incorrectFlagFeedbackTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reportHarmfulContentFeedbackSubText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reportHarmfulContentFeedbackText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sendFeedbackToAtlassianSubText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sendFeedbackToAtlassianText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	submitButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	harmfulContentFeedbackTitle: {
		id: 'ai-feedback.harmful-content.feedback-title',
		defaultMessage: 'Report harmful or inappropriate content',
		description: 'The title shown at the top of the harmful content feedback form',
	},
	feedbackTypeSelectorTitle: {
		id: 'ai-feedback.feedback-type-selector.title',
		defaultMessage: 'Report answer or leave feedback',
		description: 'The title shown at the top of the feedback type selector modal',
	},
	incorrectFlagFeedbackTitle: {
		id: 'ai-feedback.incorrect-flag.feedback-title',
		defaultMessage: 'Did we flag your input correctly?',
		description: 'The title shown at the top of the incorrect flagging feedback form',
	},
	incorrectFlagCheckboxLabel: {
		id: 'ai-feedback.incorrect-flag.checkbox-label',
		defaultMessage: 'Include your input to help us improve the system.',
		description: 'Label for the checkbox to include user input',
	},
	consentCheckboxLabel: {
		id: 'ai-feedback.consent.checkbox-label',
		defaultMessage: 'Include the last 10 messages between you and Rovo in this feedback',
		description:
			'Label for the checkbox where user gives consent to include messages from the conversation',
	},
	feedbackTextAreaLabel: {
		id: 'ai-feedback.describe-issue-label',
		defaultMessage: 'Describe the work item',
		description: 'Label for the textarea where users describe the work item',
	},
	feedbackTextAreaRequired: {
		id: 'ai-feedback.describe-issue-required',
		defaultMessage: 'Please describe the work item.',
		description: 'Error message shown when the feedback textarea is empty or has only whitespace',
	},
	harmfulContentDescription: {
		id: 'ai-feedback.harmful-content.description-default-value',
		defaultMessage: 'User reported content could be an AUP violation (false negative)',
		description:
			'Pre-filled description text in the harmful content feedback form, indicating a possible Acceptable Use Policy false negative reported by the user.',
	},
	incorrectFlagDescription: {
		id: 'ai-feedback.incorrect-flag.description-default-value',
		defaultMessage:
			'User reported possible AUP violation that was incorrectly flagged (false positive)',
		description:
			'Pre-filled description text in the incorrect flag feedback form, indicating a possible Acceptable Use Policy false positive reported by the user.',
	},
	reportHarmfulContentFeedbackText: {
		id: 'ai-feedback.feedback-type-selector.report-harmful-content.text',
		defaultMessage: 'I want to report harmful or inappropriate content',
		description: 'Text for reporting a AI output that contains harmful or inappropriate content',
	},
	sendFeedbackToAtlassianText: {
		id: 'ai-feedback.feedback-type-selector.send-feedback-to-atlassian.text',
		defaultMessage: 'I want to send feedback to Atlassian',
		description:
			'Selectable option text in the feedback type selector modal for users who want to send general feedback to Atlassian.',
	},
	reportHarmfulContentFeedbackSubText: {
		id: 'ai-feedback.feedback-type-selector.report-harmful-content.subtext',
		defaultMessage:
			'Flag this AI output for inappropriate, offensive, or otherwise malicious output',
		description: 'Subtext with more detail about reporting harmful content',
	},
	sendFeedbackToAtlassianSubText: {
		id: 'ai-feedback.feedback-type-selector.send-feedback-to-atlassian.subtext',
		defaultMessage: 'Share your feedback so we can improve these experiences.',
		description: 'Subtext with more detail about sending feedback to Atlassian',
	},
	cancelButtonText: {
		id: 'ai-feedback.cancel-button-text',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button in the AI feedback modal that dismisses the form without submitting.',
	},
	submitButtonText: {
		id: 'ai-feedback.submit-button-text',
		defaultMessage: 'Send feedback',
		description:
			'Label for the submit button in the AI feedback modal that sends the completed feedback form to Atlassian.',
	},
	displayFeedbackButtonText: {
		id: 'ai-feedback.display-feedback-button-text',
		defaultMessage: 'Display Feedback',
		description:
			'Label for the button that opens the AI feedback display panel showing previously submitted feedback.',
	},
	displayFeedbackSelectorText: {
		id: 'ai-feedback.display-feedback-selector-text',
		defaultMessage: 'Display Feedback Selector',
		description: 'Label for the display feedback selector button',
	},
});
